import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const dcourierControlSign = async (params: object) => {
  return await GET({ url: Api.dcourierControlSign, params, showError: false })
}
